module.exports = __webpack_public_path__ + "static/media/section-banner-9.59829606.svg";